import * as React from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import fetchCountByPeriod from 'modules/integrations_silae_api/lib/getSupplements'
import KomboSupplementsToSync from 'modules/payroll_integrations_kombo/components/SupplementsSyncPreview/SupplementsToSync'
import { IntegrationLabels } from 'modules/payroll_integrations_kombo/lib/constants'

interface Props {
  policyPeriodId: number
}

const SupplementsToSync = ({ policyPeriodId }: Props) => {
  const [count, setCount] = React.useState<number>(0)

  useAsyncData(async () => {
    setCount(await fetchCountByPeriod(policyPeriodId))
  }, [policyPeriodId])

  return (
    <KomboSupplementsToSync
      count={count}
      integrationLabel={IntegrationLabels.silae}
    ></KomboSupplementsToSync>
  )
}

export default SupplementsToSync
